import { useCallback } from 'react';

import {
  useAuthLocalStorage,
  UseAuthLocalStorageTriggerResult,
} from './utils/useAuthLocalStorage/useAuthLocalStorage';
import {
  useAuthMethod,
  UseAuthMethodTriggerResult,
} from './utils/useAuthMethod/useAuthMethod';
import {
  useAuthSearchParams,
  UseAuthSearchParamsTriggerResult,
} from './utils/useAuthSearchParams/useAuthSearchParams';

/** Represents the trigger callback function. */
type Trigger = () => Promise<
  | UseAuthSearchParamsTriggerResult
  | UseAuthMethodTriggerResult
  | UseAuthLocalStorageTriggerResult
>;

/** A hook that tries to resolve auth data from various strategies. */
export const useAuthDataResolver = (): Trigger => {
  const getAuthDataFromSearchParams = useAuthSearchParams();
  const getAuthDataFromAuthMethod = useAuthMethod();
  const getAuthDataFromLocalStorage = useAuthLocalStorage();

  const trigger = useCallback<Trigger>(() => {
    return getAuthDataFromSearchParams()
      .catch(getAuthDataFromAuthMethod)
      .catch(getAuthDataFromLocalStorage);
  }, [
    getAuthDataFromSearchParams,
    getAuthDataFromAuthMethod,
    getAuthDataFromLocalStorage,
  ]);

  return trigger;
};
